const quotationChat = {
  quotationChatNavLabel: "कोटेशन चैट", // translated 
  quotationChatApprovalTitle: "कोटेशन चैट", // translated 
  quotationChatAccountNotApprovedTitle: "खाता स्वीकृत नहीं हुआ", // translated 
  quotationChatAccountNotApprovedDescription:
    "आपका खाता अभी तक स्वीकृत नहीं हुआ है। अधिक जानकारी के लिए कृपया अपने खाता प्रबंधक से संपर्क करें।", // translated 
  quotationChatViewAiChat: "एआई चैट देखें", // translated 

  quotationRequestChatSessions: "चैट सत्र", // translated 
  quotationRequestChatNoPastSessions: "कोई पूर्व सत्र नहीं", // translated 
  quotationRequestChatNewChat: "नई चैट", // translated 
  quotationRequestChatCloseSidebar: "साइडबार बंद करें", // translated 
  quotationRequestChatSessionFallback: "चैट सत्र", // translated 
  quotationRequestChatDefaultSessionName: "नया चैट सत्र", // translated 
  quotationRequestChatTitle: "कोटेशन अनुरोध चैट", // translated 
  quotationRequestChatResponseLanguageLabel: "प्रतिक्रिया भाषा", // translated 
  quotationRequestChatOpenSidebar: "साइडबार खोलें", // translated 
  quotationRequestChatRenameSession: "सत्र का नाम बदलें", // translated 
  quotationRequestChatDeleteSession: "सत्र हटाएं", // translated 
  quotationRequestChatToggleDarkMode: "डार्क मोड चालू/बंद करें", // translated 
  quotationRequestChatSwitchToLightMode: "लाइट मोड पर स्विच करें", // translated 
  quotationRequestChatSwitchToDarkMode: "डार्क मोड पर स्विच करें", // translated 
  quotationRequestChatEmptyStateHeading: "कोटेशन अनुरोध के लिए एक नई बातचीत शुरू करें", // translated 
  quotationRequestChatEmptyStateSubheading:
    "अपनी यात्रा संबंधी आवश्यकताओं का वर्णन करें और मैं आपके लिए एक कोटेशन अनुरोध तैयार कर दूंगा।", // translated 
  quotationRequestChatMessagePlaceholderStart:
    "बातचीत शुरू करने के लिए अपना संदेश टाइप करें... (नई पंक्ति के लिए Shift+Enter दबाएं)", // translated 
  quotationRequestChatMessagePlaceholder: "अपना संदेश टाइप करें... (नई पंक्ति के लिए Shift+Enter दबाएं)", // translated 
  quotationRequestChatUploadFile: "फ़ाइल अपलोड करें", // translated 
  quotationRequestChatUploadAttachment: "संलग्नक अपलोड करें", // translated 

  quotationRequestChatStopGenerating: "उत्पादन बंद करो", // translated 
  quotationRequestChatGenerateQuotation: "कोटेशन जनरेट करें", // translated 
  quotationRequestChatGenerateFinalQuotation: "अंतिम कोटेशन तैयार करें", // translated 
  quotationRequestChatFinalizeQuotationRequest: "कोटेशन अनुरोध को अंतिम रूप दें", // translated 
  quotationRequestChatHoldToRecord: "वॉइस मैसेज रिकॉर्ड करने के लिए इसे दबाकर रखें", // translated 
  quotationRequestChatRecordingReleaseToSend: "रिकॉर्डिंग, भेजने के लिए रिलीज़", // translated 
  quotationRequestChatRecording: "रिकॉर्डिंग...", // translated 
  quotationRequestChatSelectSessionFirst: "कृपया पहले एक चैट सत्र चुनें।", // translated 
  quotationRequestChatCancelVoiceRecording: "वॉइस रिकॉर्डिंग रद्द करें", // translated 
  quotationRequestChatListening: "सुनना...", // translated 
  quotationRequestChatTranscribing: "प्रतिलिपि तैयार की जा रही है...", // translated 

  quotationRequestChatFileUploadedSuccess: "फ़ाइल सफलतापूर्वक अपलोड की गई।", // translated 
  quotationRequestChatUnsupportedFileType: "असमर्थित फ़ाइल प्रकार। कृपया PDF, Word (.docx), Excel (.xlsx), PowerPoint (.pptx), टेक्स्ट/CSV या छवि अपलोड करें।", // translated
  quotationRequestChatFailedCreateSession: "चैट सत्र बनाने में विफलता। कृपया पुनः प्रयास करें।", // translated 
  quotationRequestChatFailedUploadFile: "फ़ाइल अपलोड करने में विफल। कृपया पुनः प्रयास करें।", // translated 
  quotationRequestChatAnswerPendingBeforeMessage:
    "कृपया अगला संदेश भेजने से पहले लंबित प्रश्नों का उत्तर दें।", // translated 
  quotationRequestChatAnswerPendingBeforeFinalize:
    "कृपया कोटेशन अनुरोध को अंतिम रूप देने से पहले लंबित प्रश्नों का उत्तर दें।", // translated 
  quotationRequestChatFavoriteMarked: "चैट सत्र को पसंदीदा के रूप में चिह्नित किया गया", // translated 
  quotationRequestChatFavoriteUnmarked: "चैट सत्र को पसंदीदा के रूप में चिह्नित नहीं किया गया है", // translated 
  quotationRequestChatFailedSetFavorite: "पसंदीदा सेट करने में विफल", // translated 
  quotationRequestChatFailedUnsetFavorite: "पसंदीदा को हटाने में विफल", // translated 
  quotationRequestChatRenamedSuccess: "चैट सत्र का नाम सफलतापूर्वक बदल दिया गया है।", // translated 
  quotationRequestChatFailedRename: "चैट सत्र का नाम बदलने में विफलता। कृपया पुनः प्रयास करें।", // translated 
  quotationRequestChatDeletedSuccess: "चैट सत्र सफलतापूर्वक हटा दिया गया।", // translated 
  quotationRequestChatFailedDelete: "चैट सत्र को हटाने में विफलता। कृपया पुनः प्रयास करें।", // translated 
  quotationRequestChatAttachmentDeletedSuccess: "संलग्न दस्तावेज़ सफलतापूर्वक हटा दिया गया।", // translated 
  quotationRequestChatFailedDeleteAttachment: "संलग्न दस्तावेज़ को हटाने में विफलता। कृपया पुनः प्रयास करें।", // translated 
  quotationRequestChatSubmittedSuccess:
    "कोटेशन अनुरोध सफलतापूर्वक सबमिट हो गया! आपका अनुरोध प्रोसेस किया जा रहा है।", // translated 
  quotationRequestChatFailedSubmit: "कोटेशन अनुरोध सबमिट करने में विफल", // translated 
  quotationChatPdfDownloadedSuccess: "पीडीएफ सफलतापूर्वक डाउनलोड हो गई!", // translated 
  quotationChatFailedGeneratePdf: "पीडीएफ जनरेट करने में विफल", // translated 

  quotationRequestChatSubagentRequired:
    "कृपया कोटेशन अनुरोध सबमिट करने से पहले एक सब-एजेंट उपयोगकर्ता का चयन करें।", // translated 
  quotationRequestChatAppUserLoading:
    "आपके CRM ऐप का उपयोगकर्ता प्रोफ़ाइल अभी लोड हो रहा है। कृपया कुछ देर बाद पुनः प्रयास करें।", // translated 
  quotationRequestChatAppUserMismatch:
    "आपके सीआरएम ऐप का उपयोगकर्ता प्रोफ़ाइल इस चैट सत्र से मेल नहीं खाता है।", // translated 

  quotationRequestChatRenameTitle: "चैट सत्र का नाम बदलें", // translated 
  quotationRequestChatSessionName: "सत्र का नाम", // translated 
  quotationRequestChatEnterSessionName: "सत्र का नाम दर्ज करें", // translated 
  quotationRequestChatSaving: "सहेजा जा रहा है...", // translated 
  quotationRequestChatSave: "बचाना", // translated 
  quotationRequestChatDeleteTitle: "चैट सत्र हटाएं", // translated 
  quotationRequestChatDeleteConfirm: "क्या आप वाकई इस चैट सेशन को डिलीट करना चाहते हैं?", // translated 
  quotationRequestChatDeleteCannotUndo: "इस एक्शन को वापस नहीं किया जा सकता।", // translated 
  quotationRequestChatDeleting: "हटा रहा हूँ...", // translated 
  quotationRequestChatDelete: "मिटाना", // translated 

  quotationRequestChatAttachmentsTitle: "कोटेशन अनुरोध चैट अटैचमेंट", // translated 
  quotationRequestChatLoadingAttachments: "संलग्नक लोड हो रहे हैं...", // translated 
  quotationRequestChatNoAttachments: "कोई अटैचमेंट नहीं मिला", // translated 
  quotationRequestChatDeleteAttachment: "संलग्नक हटाएं", // translated 
  quotationRequestChatUploadingAttachment: "संलग्न दस्तावेज़ अपलोड किया जा रहा है...", // translated 
  quotationRequestChatUploadingAttachmentWait: "कृपया प्रतीक्षा करें, आपकी फ़ाइल अपलोड हो रही है।", // translated 

  quotationRequestChatAnswerPendingQuestions: "लंबित प्रश्नों के उत्तर दें", // translated 
  quotationRequestChatProposeOwnAnswer: "अपना उत्तर प्रस्तावित करें", // translated 
  quotationRequestChatTypeOwnAnswerPlaceholder: "अपना उत्तर स्वयं लिखें...", // translated 
  quotationRequestChatAnsweredOfTotal: "कुल उत्तरों में से {{उत्तर दिया गया}}", // translated 
  quotationRequestChatReadyToSubmit: "जमा करने के लिए तैयार", // translated 
  quotationRequestChatSubmitAll: "सभी को प्रस्तुत करें", // translated 
  quotationRequestChatRespondToOneQuestion: "{{count}} प्रश्नों का उत्तर दें", // translated 
  quotationRequestChatRespondToManyQuestions: "{{count}} प्रश्नों का उत्तर दें", // translated 

  quotationRequestChatFinalizeTitle: "कोटेशन अनुरोध को अंतिम रूप दें", // translated 
  quotationRequestChatLoadingSessionData: "सेशन डेटा लोड हो रहा है...", // translated 
  quotationRequestChatErrorLoadingSession: "सेशन डेटा लोड करने में त्रुटि। कृपया पुनः प्रयास करें।", // translated 
  quotationRequestChatQuotationTitle: "उद्धरण शीर्षक", // translated 
  quotationRequestChatExtraComments: "अतिरिक्त टिप्पणियाँ", // translated 
  quotationRequestChatSubmitting: "सबमिट किया जा रहा है...", // translated 
  quotationRequestChatSubmit: "जमा करना", // translated 
  quotationRequestChatSubmittingOverlayTitle: "कोटेशन अनुरोध सबमिट किया जा रहा है...", // translated 
  quotationRequestChatSubmittingOverlayDescription:
    "कृपया प्रतीक्षा करें, आपकी कोटेशन रिक्वेस्ट सबमिट की जा रही है।", // translated 

  quotationRequestChatSelectSubagent: "उप-एजेंट का चयन करें", // translated 
  quotationRequestChatSearchSubagents: "उप-एजेंटों की खोज करें...", // translated 
  quotationRequestChatLoadingSubagents: "उप-एजेंट लोड हो रहे हैं...", // translated 
  quotationRequestChatNoSubagentsFound: "कोई उप-एजेंट नहीं मिला", // translated 
  quotationRequestChatNoSubagentsAvailable: "कोई उप-एजेंट उपलब्ध नहीं हैं", // translated 
  quotationRequestChatSelectedSubagent: "चयनित: {{लेबल}}", // translated 

  quotationRequestChatSubagentUsers: "उप-एजेंट उपयोगकर्ता", // translated 
  quotationRequestChatSearchUsers: "उपयोगकर्ताओं को खोजें...", // translated 
  quotationRequestChatNoUsersFound: "कोई उपयोगकर्ता नहीं मिला", // translated 
  quotationRequestChatNoUsersAvailable: "कोई उपयोगकर्ता उपलब्ध नहीं हैं", // translated 

  quotationChatDownloadSummaryTitle: "अपने कोटेशन का सारांश डाउनलोड करें", // translated 
  quotationChatDownloadSummaryDescription:
    "अपनी यात्रा के विवरण भरकर अपनी यात्रा का व्यक्तिगत पीडीएफ़ कोटेशन प्राप्त करें। इस पीडीएफ़ में यात्रा से संबंधित सभी विवरण, गंतव्य स्थान, परिवहन जानकारी और दिन-प्रतिदिन का कार्यक्रम शामिल होगा।", // translated 
  quotationChatCustomerTitle: "शीर्षक", // translated 
  quotationChatSelectTitle: "शीर्षक चुनें", // translated 
  quotationChatHonorificMr: "श्री।", // translated 
  quotationChatHonorificMrs: "श्रीमती।", // translated 
  quotationChatHonorificMs: "एमएस।", // translated 
  quotationChatHonorificDr: "डॉ।", // translated 
  quotationChatHonorificProf: "प्रो", // translated 
  quotationChatCustomerPhone: "फ़ोन", // translated 
  quotationChatCustomerCompany: "कंपनी", // translated 
  quotationChatCustomerMessage: "संदेश", // translated 
  quotationChatCustomerCountry: "देश", // translated 
  quotationChatGenerating: "जनरेट हो रहा है...", // translated 
  quotationChatDownloadPdf: "पीडीएफ डाउनलोड करें", // translated 

  quotationChatTripSummary: "यात्रा का सारांश", // translated 
  quotationChatDownloadAsPdf: "पीडीएफ के रूप में डाउनलोड करें", // translated 
  quotationChatNoTripSummary: "इस सत्र के लिए कोई यात्रा सारांश उपलब्ध नहीं है।", // translated 

  quotationRequestChatThinking: "सोच...", // translated 
  quotationRequestChatSources: "सूत्रों का कहना है", // translated 
  quotationRequestChatSearchingWebFor: 'वेब पर खोज रहे हैं: "{{query}}"...', // translated 
  quotationRequestChatServicesByTourOperator: "टूर ऑपरेटर द्वारा प्रदान की जाने वाली सेवाएं", // translated 
  quotationRequestChatServicesByCustomer: "ग्राहक द्वारा प्रदान की जाने वाली सेवाएं", // translated 
  quotationRequestChatReadyNotice:
    "अब आप दाईं ओर स्थित बटन पर क्लिक करके इस अनुरोध के लिए एक कोटेशन प्राप्त कर सकते हैं।", // translated 
  quotationRequestChatGenerateFinalQuotationAria: "अंतिम कोटेशन तैयार करें", // translated 

  quotationRequestChatMaybeYouWantToAsk: "शायद आप पूछना चाहें:", // translated 
  quotationRequestChatClickToSendSuggestion: "यह संदेश भेजने के लिए क्लिक करें", // translated 

  quotationRequestChatAddToFavorites: "पसंदीदा में जोड़े", // translated 
  quotationRequestChatRemoveFromFavorites: "पसंदीदा से हटाएँ", // translated 
  quotationRequestChatSubmitted: "प्रस्तुत किया गया", // translated 

  quotationRequestChatQuotationRequest: "कोटेशन अनुरोध: {{reference}}", // translated 
  quotationRequestChatQuotationTooltipTitle: "{{शीर्षक}}", // translated 
  quotationRequestChatQuotationTooltipStatus: "- स्थिति: {{status}}", // translated 

  quotationChatLoading: "लोड हो रहा है...", // translated 
  quotationChatSessionNotFound: "इस उद्धरण के लिए चैट सत्र नहीं मिला।", // translated 
  quotationChatMemberSessionNotFound: "आपके खाते के लिए सदस्य सत्र नहीं मिला", // translated 
  quotationChatUnableToConnect: "चैट से कनेक्ट करने में असमर्थ", // translated 
  quotationChatConnecting: "कनेक्ट हो रहा है...", // translated 
  quotationChatTypeYourMessage: "अपना संदेश टाइप करें...", // translated 
  quotationChatConnected: "जुड़े हुए", // translated 
  quotationChatConnectingStatus: "कनेक्ट हो रहा है...", // translated 
  quotationChatDisconnected: "डिस्कनेक्ट किया गया", // translated 
};


export default quotationChat;
